import { useSubheader } from "../../../../_metronic/layout";
import React, { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { paymentSagaActions } from "..";

import { Card, Modal, ModalBody, Spinner } from "react-bootstrap";
import { getRefIdByCode } from "../../../../utilities/lookup";
import logman from "../../../../utilities/logman";


export const PaymentResult = (props) => {
  const subheader = useSubheader();
  const dispatch = useDispatch();
  const history = useHistory();

  const { reference, payment } = useSelector(state => state);

  subheader.setTitle("Payment Result");

  const { orderInfo, paymentSuccessful, paymentFailed, creatingPayment } = payment;

  const { allReferences } = reference;


  const createBSPPayPayment = useCallback(() => {

    let currentUrl = window.location.href;
    let paramString = currentUrl.split('?')[1];
    let queryString = new URLSearchParams(paramString);

    let trx = queryString.get('trx');
    
    let params = {
      customerId: orderInfo.customerId,
      orderId: orderInfo.orderId,
      encryptedPayload: trx
    };
    
    dispatch(paymentSagaActions.createBSPPayPayment(params));

  },[ orderInfo.customerId, orderInfo.orderId,dispatch]);


  const createBSPCardPayment = useCallback(() => {

    let currentUrl = window.location.href;
    let paramString = currentUrl.split('?')[1];
    let queryString = new URLSearchParams(paramString);
    logman.debug("PaymentResult::createBSPCardPayment::paramString: " + paramString);
    let data = queryString.get('data');
    logman.debug("PaymentResult::createBSPCardPayment::data: " + data);
    let params = {
      customerId: orderInfo.customerId,
      orderId: orderInfo.orderId,
      encryptedPayload: data
    };

    dispatch(paymentSagaActions.createBSPCardPayment(params));
    
  },[ orderInfo.customerId, orderInfo.orderId, dispatch]);

  useEffect(() => {

    const getPaymentResult = () => {

      //logman.debug("Order Info: " + JSON.stringify(orderInfo));

      if(orderInfo.orderId === undefined || orderInfo.customerId === undefined || orderInfo.paymentRailTypeId === undefined){
        history.push('/catalogue-management/region');
      } else {
  
        switch (orderInfo.paymentRailTypeId) {
          case getRefIdByCode(allReferences, 'CCARD', 'PAYMENT_RAIL_TYPE'):
            createBSPCardPayment();
            break;
          case getRefIdByCode(allReferences, 'BSPPAY', 'PAYMENT_RAIL_TYPE'):
            createBSPPayPayment();
            break;
          default:
            break;
        }
  
      }    
    };

    getPaymentResult();
    
  }, [orderInfo.orderId,orderInfo.customerId,orderInfo.paymentRailTypeId,createBSPCardPayment,createBSPPayPayment, allReferences, history]);

  useEffect(() => {

    //logman.debug("Payment Redux State: " + JSON.stringify(payment));

    if (paymentSuccessful){
      history.push('/payment-management/payment-successful');
    } else if (paymentFailed) {
      history.push('/payment-management/payment-failed');
    }
  }, [history, paymentSuccessful, paymentFailed]);

  return (
    <Card>
      <Modal show={creatingPayment} aria-labelledby="contained-modal-title-vcenter" centered >
        <ModalBody className="d-flex align-items-center">
          <Spinner animation="grow" size="lg" variant="warning" /> <span className="pl-5"> Retrieving your payment results... </span>
        </ModalBody>
      </Modal>
    </Card>
  );
};
